import Tdg_CompanyUpdateModelBase from '../_generated/modelBases/tdg-company-update-model-base';

export default class Tdg_CompanyUpdateModel extends Tdg_CompanyUpdateModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
